import styles from "./pageContainer.module.css";

const PageContainer = ({ children, header }) => {
  return (
    <div className={styles.pageContainerWithHeader}>
      {!!header ? <h1>{header}</h1> : null}
      <div className={styles.pageContainer}>{children}</div>
    </div>
  );
};

export default PageContainer;
